var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-container",style:(_vm.getMainGameSyle())},[_c('div',{attrs:{"id":"game-container"}},[_c('canvas',{style:(_vm.getStyle()),attrs:{"id":"gameCanvas"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }